import React, { useCallback, useEffect, useState } from "react";
import dataimage from "../../images/Icons/ledger.png";
import axios from "axios";
import config from "../../config";
import Dataloader from "../../Component/Dataloader";

export default function HistoricalData() {
  const formatDate = (date) => date.toISOString().split("T")[0];
  const todayDate = formatDate(new Date());
  const [data, setData] = useState({
    startdate: formatDate(
      new Date(new Date().setDate(new Date().getDate() - 30))
    ),
    enddate: formatDate(new Date()),
    city: [],
    historyData: [],
  });
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);
  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiUrl}/ingot-price-history`, {
        params: {
          from_date: data.startdate,
          to_date: data.enddate,
          ingot_location: city,
        },
      });
      setData((prevData) => ({
        ...prevData,
        city: response.data.location,
        historyData: response.data.data,
      }));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [city, data.enddate, data.startdate]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="ingot-updates mrb1">
            <div className="row g-3 row-hd-txt">
              <div className="col-lg-6 col-md-6">
                <div className="row-hd-txt-left">
                  <img src={dataimage} alt="icon" />
                  <h5>Historical Data</h5>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="row g-2 int-dt">
                  <div className="col-lg-4 col-md-4 col-6 px-2">
                    <input
                      type="date"
                      value={data.startdate}
                      max={todayDate}
                      onChange={(e) => {
                        const newStartDate = e.target.value;

                        setData({
                          ...data,
                          startdate:
                            newStartDate > todayDate ? todayDate : newStartDate,
                          enddate:
                            newStartDate > data.enddate
                              ? newStartDate
                              : data.enddate,
                        });
                      }}
                      title="Start Date"
                    />
                  </div>
                  <div className="col-lg-4 col-md-4 col-6 px-2">
                    <input
                      type="date"
                      value={data.enddate}
                      min={data.startdate}
                      max={todayDate}
                      onChange={(e) => {
                        const newEndDate = e.target.value;

                        setData({
                          ...data,
                          enddate:
                            newEndDate > todayDate ? todayDate : newEndDate,
                        });
                      }}
                      title="End Date"
                    />
                  </div>
                  <div className="col-lg-4 col-md-4 px-2">
                    <select
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    >
                      {data.city.map((cityData, index) => (
                        <option key={index} value={cityData}>
                          {cityData}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="ingt-table table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Open</th>
                        <th scope="col">High</th>
                        <th scope="col">Low</th>
                        <th scope="col">Close</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={5}>
                            <div className="d-flex justify-content-center">
                              <Dataloader />
                            </div>
                          </td>
                        </tr>
                      ) : data.historyData.length > 0 ? (
                        data.historyData.map((hist, index) => (
                          <tr key={index}>
                            <td>{hist.date}</td>
                            <td>{hist.open}</td>
                            <td>{hist.high}</td>
                            <td>{hist.low}</td>
                            <td>{hist.close}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            className="text-center fw-bold text-danger"
                            colSpan={5}
                          >
                            Oops! No Data Found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
